export const iconFontAwesomeArrowsLocationArrow = (
	<i className="fa-solid fa-location-arrow"></i>
);
